import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { auth } from "../firebase";
import { getDatabase, ref, onValue, update } from "firebase/database";
import { onAuthStateChanged } from "firebase/auth";
import AddProductForm from "./AddProductForm";
import AdminDeposit from "./AdminDeposit";
import { FaAngleRight, FaAngleLeft } from "react-icons/fa";
import { toast } from "react-toastify";

// Fungsi untuk mengambil data pesanan dari Firebase
const fetchOrders = (setNotifications) => {
    const db = getDatabase();
    const ordersRef = ref(db, "orders");

    // Mendengarkan perubahan data
    onValue(ordersRef, (snapshot) => {
        const ordersData = snapshot.val();

        if (ordersData) {
            const allOrders = [];
            Object.keys(ordersData).forEach((userId) => {
                const userOrders = ordersData[userId];
                Object.keys(userOrders).forEach((orderId) => {
                    const order = userOrders[orderId];
                    allOrders.push({
                        userId, // User ID tetap disimpan
                        orderId,
                        date: order.date,
                        items: Array.isArray(order.items) ? order.items : [], // Pastikan items berupa array
                        totalPrice: order.totalPrice,
                        status: order.status || "pending"
                    });
                });
            });

            // Update state dengan semua pesanan
            setNotifications(allOrders);
        } else {
            setNotifications([]); // Jika tidak ada data
        }
    });
};

const AdminDashboard = () => {
    const navigate = useNavigate();
    const [notifications, setNotifications] = useState([]);
    const [statuses, setStatuses] = useState({});
    const [currentPage, setCurrentPage] = useState(0);
    const [searchQuery, setSearchQuery] = useState("");
    const itemsPerPage = 5;

    // Cek autentikasi admin
    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, (user) => {
            if (user) {
                if (user.email !== "padild940@gmail.com") {
                    navigate("/");
                }
            } else {
                navigate("/");
            }
        });

        // Panggil fungsi fetchOrders untuk mengambil data
        fetchOrders(setNotifications);

        return () => unsubscribe();
    }, [navigate]);

    // Fungsi untuk mengubah status pesanan
    const updateOrderStatus = (userId, orderId, newStatus) => {
        const db = getDatabase();
        const orderRef = ref(db, `orders/${userId}/${orderId}`);
        update(orderRef, { status: newStatus })
            .then(() => {
                toast.success(`Status pesanan diubah menjadi ${newStatus}`);
                setStatuses((prevStatuses) => ({
                    ...prevStatuses,
                    [orderId]: newStatus
                }));
            })
            .catch((error) => {
                console.error("Gagal memperbarui status:", error);
            });
    };

    const convertTimestampToDate = (timestamp) => {
        const date = new Date(timestamp);
        return date.toLocaleString("id-ID", {
            day: "2-digit",
            month: "long",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit"
        });
    };

    // Fungsi untuk memberikan warna status
    const getStatusColor = (status) => {
        switch (status) {
            case "pending":
                return "bg-yellow-200 text-yellow-800";
            case "tolak":
                return "bg-red-200 text-red-800";
            case "success":
                return "bg-green-200 text-green-800";
            default:
                return "bg-yellow-200 text-yellow-800";
        }
    };

    // Filter data berdasarkan pencarian
    const filteredData = notifications.filter((notification) => {
        const productName = notification.items?.[0]?.name?.toLowerCase() || "";
        const userId = notification.userId?.toLowerCase() || "";
        const query = searchQuery.toLowerCase();
        return productName.includes(query) || userId.includes(query);
    });

    // Data untuk halaman saat ini
    const currentData = filteredData.slice(
        currentPage * itemsPerPage,
        (currentPage + 1) * itemsPerPage
    );

    // Navigasi halaman
    const nextPage = () => {
        if ((currentPage + 1) * itemsPerPage < filteredData.length) {
            setCurrentPage(currentPage + 1);
        }
    };

    const prevPage = () => {
        if (currentPage > 0) {
            setCurrentPage(currentPage - 1);
        }
    };

    return (
        <div className="p-6">
            <h1 className="text-3xl font-bold mb-4">Halaman Admin</h1>

            {/* Daftar Deposit */}
            <AdminDeposit />

            {/* Input Pencarian */}
            <div className="mb-4">
                <input
                    type="text"
                    placeholder="Cari berdasarkan User ID atau Nama Produk"
                    className="w-full p-2 border rounded-md"
                    value={searchQuery}
                    onChange={(e) => {
                        setSearchQuery(e.target.value);
                        setCurrentPage(0);
                    }}
                />
            </div>

            {/* Daftar Pesanan */}
            <div className="mb-4 p-4 bg-gray-100 rounded-md">
                <h2 className="text-lg font-semibold mb-4">Daftar Pesanan</h2>
                {filteredData.length > 0 ? (
                    <>
                        <div className="overflow-x-auto">
                            <table className="w-full table-auto border-collapse border border-gray-200">
                                <thead>
                                    <tr className="bg-gray-300">
                                        <th className="border p-2">User ID</th>
                                        <th className="border p-2">
                                            Product ID
                                        </th>
                                        <th className="border p-2">
                                            Nama Produk
                                        </th>
                                        <th className="border p-2">Tanggal</th>
                                        <th className="border p-2">
                                            Total Harga
                                        </th>
                                        <th className="border p-2">Status</th>
                                        <th className="border p-2">Aksi</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {currentData.map((notification) => (
                                        <tr
                                            key={notification.orderId}
                                            className="text-center"
                                        >
                                            <td className="border p-2">
                                                {notification.userId}
                                            </td>
                                            <td className="border p-2">
                                                {notification.orderId}
                                            </td>
                                            <td className="border p-2">
                                                {notification.items &&
                                                notification.items.length > 0
                                                    ? notification.items
                                                          .map(
                                                              (item) =>
                                                                  item.name
                                                          )
                                                          .join(", ")
                                                    : "No products"}
                                            </td>

                                            <td className="border p-2">
                                                {convertTimestampToDate(
                                                    notification.date
                                                )}
                                            </td>
                                            <td className="border p-2">
                                                Rp{" "}
                                                {notification.totalPrice}
                                            </td>
                                            <td className="border p-2">
                                                <span
                                                    className={`px-3 py-1 rounded-full text-sm font-medium ${getStatusColor(
                                                        statuses[
                                                            notification.orderId
                                                        ] || notification.status
                                                    )}`}
                                                >
                                                    {statuses[
                                                        notification.orderId
                                                    ] || notification.status}
                                                </span>
                                            </td>
                                            <td className="border p-2">
                                                <select
                                                    className="p-2 border rounded-md"
                                                    value={
                                                        statuses[
                                                            notification.orderId
                                                        ] || notification.status
                                                    }
                                                    onChange={(e) =>
                                                        updateOrderStatus(
                                                            notification.userId,
                                                            notification.orderId,
                                                            e.target.value
                                                        )
                                                    }
                                                >
                                                    <option value="pending">
                                                        Tunda
                                                    </option>
                                                    <option value="tolak">
                                                        Tolak
                                                    </option>
                                                    <option value="success">
                                                        Sukses
                                                    </option>
                                                </select>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>

                        {/* Navigasi halaman */}
                        <div className="flex justify-center items-center mt-4">
                            <button
                                onClick={prevPage}
                                disabled={currentPage === 0}
                                className={`px-4 py-2 border ${
                                    currentPage === 0
                                        ? "bg-gray-300 cursor-not-allowed"
                                        : "bg-blue-500 text-white"
                                }`}
                            >
                                <FaAngleLeft />
                            </button>
                            <span className="px-4">
                                Halaman {currentPage + 1} dari{" "}
                                {Math.ceil(filteredData.length / itemsPerPage)}
                            </span>
                            <button
                                onClick={nextPage}
                                disabled={
                                    (currentPage + 1) * itemsPerPage >=
                                    filteredData.length
                                }
                                className={`px-4 py-2 border ${
                                    (currentPage + 1) * itemsPerPage >=
                                    filteredData.length
                                        ? "bg-gray-300 cursor-not-allowed"
                                        : "bg-blue-500 text-white"
                                }`}
                            >
                                <FaAngleRight />
                            </button>
                        </div>
                    </>
                ) : (
                    <p className="text-center">
                        Tidak ada pesanan yang sesuai.
                    </p>
                )}
            </div>

            {/* Form Tambah Produk */}
            <AddProductForm />
        </div>
    );
};

export default AdminDashboard;
